<template>
  <v-card
    :data-cy="`space-${space.id}`"
    style="padding-bottom: 50px">
    <v-card-item>
      <v-card-title>{{ space.name }} </v-card-title>
      <v-card-subtitle>
        <v-avatar
          color="secondary"
          v-for="user in space.users.filter((u) => u.isActive)"
          :key="user.id">
          {{ user.first_name[0] }}{{ user.last_name[0] }}
        </v-avatar>
      </v-card-subtitle>
      <v-card-subtitle>{{ space.description }} </v-card-subtitle>
      <template #append>
        <v-fab
          v-if="space.rights & SPACE_RIGHT_ADMIN"
          elevation="0"
          icon="mdi-cog"
          @click.prevent="emit('edit-space')"></v-fab>

        <v-fab
          v-else-if="!space.organization"
          elevation="0"
          icon="mdi-logout"
          @click.prevent="leaveSpace(space.id)"></v-fab>
      </template>
    </v-card-item>

    <v-card-text>
      <CostBreakDownSmall :spaceId="space.id" />
    </v-card-text>

    <v-card-actions style="position: absolute; bottom: 0; width: 100%">
      <v-spacer />
      <v-btn
        v-if="space.state === 1"
        elevation="3"
        data-cy="open-space"
        @click="goToSpace(space.id)"
        >Öffnen</v-btn
      >
      <template v-else>
        <v-btn
          elevation="3"
          data-cy="decline-invitation"
          @click="mainStore.declineInvitation(space.id)"
          >Ablehnen</v-btn
        >
        <v-btn
          elevation="3"
          data-cy="accept-invitation"
          @click="mainStore.acceptInvitation(space.id)"
          >Annehmen</v-btn
        >
      </template>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/mainStore";
import { useRoute, useRouter } from "vue-router";
import { SPACE_RIGHT_ADMIN } from "@/utils/constants";
import { useConfirmComposable } from "@/utils/confirmComposable";
import CostBreakDownSmall from "../CostBreakDownSmall.vue";

const router = useRouter();
const mainStore = useMainStore();
const confirm = useConfirmComposable();

const props = defineProps(["space"]);
const emit = defineEmits(["edit-space"]);

const goToSpace = (spaceId: number) => {
  router.push(`/calc/${spaceId}`);
};

function leaveSpace(spaceId: string) {
  confirm("remove-space").then(() => {
    mainStore.removeSpace(spaceId);
  });
}
</script>
